import React, { useState } from 'react';
import Tooltip from '../../../../../muiComponents/Tooltip';
import useTranslate from '../../../../../customHooks/useTranslate';
import UnsavedServicesChangesPopUp from './UnsavedServicesChangesPopUp';

interface ZitoneoLinkProps {
    isLoading: boolean;
    hasUnsavedChanges: boolean;

    onClick: () => void;
    onSave: () => Promise<void>;
}

const ZitoneoLink = ({
    isLoading,
    hasUnsavedChanges,
    onClick,
    onSave,
}: ZitoneoLinkProps) => {
    const translate = useTranslate();
    const [isWarningOpen, setIsWarningOpen] = useState(false);

    const handleClick = (e: React.MouseEvent<HTMLImageElement>) => {
        if (isLoading) {
            e.preventDefault();
            return;
        }

        if (hasUnsavedChanges) {
            e.preventDefault();
            setIsWarningOpen(true);
        } else {
            onClick();
        }
    };

    return (
        <>
            <Tooltip titleText={translate('back_to_properties')}>
                <h1
                    className='zitoneo-header__title cursor-pointer'
                    onClick={handleClick}
                >
                    Zitoneo
                </h1>
            </Tooltip>
            <UnsavedServicesChangesPopUp
                isOpen={isWarningOpen}
                onClose={() => {
                    setIsWarningOpen(false);
                    onClick();
                }}
                onSave={async () => {
                    await onSave();
                    setIsWarningOpen(false);
                }}
            />
        </>
    );
};

export default ZitoneoLink;
